import {takeEvery} from 'redux-saga/effects'
import {
  ATTENDANCE_ADD_ATTENDANCE_REMARKS,
  ATTENDANCE_SETTING,
  ATTENDANCE_SETTINGS_BY_BRANCH,
  ATTENDANCE_SETTING_CREATE,
  ATTENDANCE_UPLOAD,
  GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT,
  GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT,
  GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT,
  GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_STUDENT_MONTHWISE_REPORT,
  GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT,
  GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT,
  GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT,
  GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT,
  GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT,
  GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT,
  GET_STD_MOTNTHWISE_ATTENDANCE,
  GET_TODAY_ATTENDANCE,
  MARK_USER_ATTENDANCE,
  SEND_ATTENDANCE_WARNING,
  UNMARK_USER_ATTENDANCE,
  UPDATE_ATTENDANCE_SETTING,
  UPDATE_USER_ATTENDANCE,
} from 'setup/redux/Actions/Attendance/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(ATTENDANCE_UPLOAD, fetchData)
  yield takeEvery(GET_TODAY_ATTENDANCE, fetchData)
  yield takeEvery(GET_STD_MOTNTHWISE_ATTENDANCE, fetchData)
  yield takeEvery(MARK_USER_ATTENDANCE, fetchData)
  yield takeEvery(UNMARK_USER_ATTENDANCE, fetchData)
  yield takeEvery(ATTENDANCE_SETTING, fetchData)
  yield takeEvery(UPDATE_ATTENDANCE_SETTING, fetchData)
  yield takeEvery(ATTENDANCE_ADD_ATTENDANCE_REMARKS, fetchData)
  yield takeEvery(ATTENDANCE_SETTINGS_BY_BRANCH, fetchData)
  yield takeEvery(UPDATE_USER_ATTENDANCE, fetchData)
  yield takeEvery(GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT, fetchData)
  yield takeEvery(GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_MONTHWISE_REPORT, fetchData)
  yield takeEvery(ATTENDANCE_SETTING_CREATE, fetchData)
  yield takeEvery(SEND_ATTENDANCE_WARNING, fetchData)
}

export default dataSaga
